export default __webpack_public_path__ + "static/media/download.41d62ad3.svg";